document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  var root = document.querySelector('[data-lux-affiliate]');
  if (!root) return;

  var header = document.querySelector('[data-lux-site-header]');

  function getHeaderOffset() {
    return (header ? header.offsetHeight : 0) + 16;
  }

  function scrollToEl(el) {
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  root.querySelectorAll('[data-lux-affiliate-scroll]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      var targetId = el.getAttribute('href');
      if (!targetId || targetId.charAt(0) !== '#') return;
      var target = document.querySelector(targetId);
      if (!target) return;
      e.preventDefault();
      scrollToEl(target);
      if (targetId === '#apply') {
        var firstInput = target.querySelector('input:not([type="hidden"])');
        if (firstInput) {
          window.setTimeout(function () {
            firstInput.focus({ preventScroll: true });
          }, 500);
        }
      }
    });
  });

  var form = root.querySelector('[data-lux-affiliate-form]');
  if (form) {
    form.addEventListener('submit', function () {
      var first = form.querySelector('[name="lux_first_name"]');
      var last = form.querySelector('[name="lux_last_name"]');
      var social = form.querySelector('[name="lux_social"]');
      var audience = form.querySelector('[name="lux_audience"]');
      var whyField = form.querySelector('[name="lux_why"]');
      var nameField = form.querySelector('[name="contact[name]"]');
      var bodyField = form.querySelector('[name="contact[body]"]');

      if (nameField && first && last) {
        nameField.value = (first.value + ' ' + last.value).trim();
      }

      if (bodyField) {
        var parts = ['Affiliate Program Application'];
        if (social && social.value.trim()) parts.push('Social / website: ' + social.value.trim());
        if (audience && audience.value) parts.push('Audience size: ' + audience.value);
        if (whyField && whyField.value.trim()) parts.push('', whyField.value.trim());
        bodyField.value = parts.join('\n');
      }

      if (form.dataset.submitting === 'true') return;
      form.dataset.submitting = 'true';

      var btn = form.querySelector('[data-lux-affiliate-submit]');
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      }
    });
  }

  if (root.querySelector('.lux-affiliate-form-success')) {
    var card = root.querySelector('#lux-affiliate-form-card');
    window.setTimeout(function () {
      scrollToEl(card);
    }, 120);
  }
});
